import React from 'react';

function CompositionChart({ summary, t }) {
  if (!summary) return null;

  const { corte_pct = 0, restante_pct = 0, entre_cortes_pct = 0 } = summary;
  const total = corte_pct + restante_pct + entre_cortes_pct;
  const otherPct = Math.max(0, 100 - total);

  return (
    <div className={`${t.card} rounded-lg p-6`}>
      <h3 className={`text-sm font-semibold ${t.text} mb-4`} style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>
        Composição
      </h3>
      <div className="flex items-center justify-center gap-6">
        <div className="w-32 h-32 rounded-full relative" style={{
          background: `conic-gradient(
            #10b981 0% ${corte_pct}%, 
            #f59e0b ${corte_pct}% ${corte_pct + restante_pct}%, 
            #ef4444 ${corte_pct + restante_pct}% ${corte_pct + restante_pct + entre_cortes_pct}%${otherPct > 0.5 ? `,
            #6b7280 ${corte_pct + restante_pct + entre_cortes_pct}% 100%` : ''}
          )`
        }}>
          <div className={`absolute inset-4 ${t.cardFlat} rounded-full flex items-center justify-center`}>
            <span className={`text-lg font-bold ${t.text}`}>{total.toFixed(1)}%</span>
          </div>
        </div>
        <div className="space-y-2 text-xs">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-emerald-500 rounded" />
            <span className={t.textBody}>Corte: {corte_pct.toFixed(1)}%</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-amber-500 rounded" />
            <span className={t.textBody}>Parada: {restante_pct.toFixed(1)}%</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-red-500 rounded" />
            <span className={t.textBody}>Entre: {entre_cortes_pct.toFixed(1)}%</span>
          </div>
          {otherPct > 0.5 && (
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-gray-500 rounded" />
              <span className={t.textBody}>Pausas: {otherPct.toFixed(1)}%</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CompositionChart;
